import React, { useContext } from 'react';
import { Route } from 'react-router-dom';

import NotAcceptPermission from 'views/pages/NotAcceptPermission';

const PrivateRoute = (props) => {
  const { path, component, ThemContext, permissionName, viewRole } = props;
  const { canViewRoute } = useContext(ThemContext);
  return (
    <Route path={path}>
      {canViewRoute({ permission: permissionName, viewRole }) ? React.createElement(component) : <NotAcceptPermission />}
    </Route>
  );
};

export default PrivateRoute;
